import * as ACTION_TYPES from "./action-types";

/**
 * Action to toggle/show UserProfileSidebar
 * @param {Object} data - Object with showUserProfileSidebar boolean
 * @returns {Object} Action object
 */
export const setShowUserProfileSidebar = (data) => {
  return {
    type: ACTION_TYPES.TOGGLE_USER_PROFILE_SIDEBAR,
    payload: data,
  };
};

/**
 * Action to set expanded sections in UserProfileSidebar
 * @param {Array} data - Array of expanded section IDs
 * @returns {Object} Action object
 */
export const setExpanded = (data) => {
  return {
    type: ACTION_TYPES.SET_USER_PROFILE_SIDEBAR_EXPANDED,
    payload: data,
  };
};

/**
 * Action to set focused element in UserProfileSidebar
 * @param {String} elementId - ID of the focused element
 * @returns {Object} Action object
 */
export const setFocusedElement = (elementId) => {
  return {
    type: ACTION_TYPES.SET_USER_PROFILE_SIDEBAR_FOCUSED_ELEMENT,
    payload: elementId,
  };
};

